// Hawaiian translations
export const haw: Record<string, string> = {
  'menu.dashboard': "Papa Hoʻoponopono",
  'menu.customers': 'Nā Mea Kūʻai',
  'menu.products': 'Nā Huahana',
  'menu.users': 'Nā Mea Hoʻohana',
  'menu.settings': 'Nā Hoʻonohonoho',
  'menu.logout': "Ha'alele",
  'dashboard.title': "Papa Hoʻoponopono",
  'dashboard.newOrder': 'Kauoha Hou',
  'order.title': 'Kauoha Hou',
  'order.customer': 'Mea Kūʻai',
  'order.products': 'Nā Huahana',
  'order.total': 'Huina',
  'users.title': 'Nā Mea Hoʻohana',
  'users.name': 'Inoa',
  'users.email': 'Leka Uila',
  'common.yes': "ʻAe",
  'common.no': "ʻAʻole",
  'common.cancel': "Ho'opau",
  'common.save': 'Mālama',
  'common.search': "ʻImi",
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': "ʻEʻe",
  'login.welcome': 'Aloha, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'Leka Uila',
  'signup.phone': 'Kelepona',
};